if (!customElements.get('cart-recommendations')) {
  customElements.define('cart-recommendations', class extends HTMLElement {
    connectedCallback() {
      this.track = this.querySelector('.cart-recommendations__track');
      if (!this.track || this.controller) return;
      this.controller = new AbortController();
      const { signal } = this.controller;
      this.previous = this.querySelector('[data-direction="previous"]');
      this.next = this.querySelector('[data-direction="next"]');
      this.navigation = this.querySelector('.cart-recommendations__navigation');
      this.addEventListener('click', (event) => {
        const material = event.target.closest('[data-material]');
        if (material?.matches('button')) {
          this.selectMaterial(material.closest('.cart-recommendations__card'), material.dataset.material);
          return;
        }
        const arrow = event.target.closest('[data-direction]');
        if (!arrow) return;
        const direction = arrow.dataset.direction === 'next' ? 1 : -1;
        const rtl = getComputedStyle(this.track).direction === 'rtl' ? -1 : 1;
        this.track.scrollBy({
          left: direction * rtl * this.track.clientWidth,
          behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth'
        });
      }, { signal });
      this.querySelectorAll('.cart-recommendations__card').forEach((card) => {
        const select = card.querySelector('.cart-recommendations__variants');
        if (!select) return;
        // Keep every variant so changing material can rebuild the size list.
        card.variantOptions = card.variantOptions || Array.from(select.options, (option) => option.cloneNode(true));
        this.selectMaterial(card, select.selectedOptions[0]?.dataset.material || '');
        const materials = card.querySelector('.cart-recommendations__materials');
        if (materials) materials.hidden = false;
        select.hidden = select.dataset.hideSize === 'true';
      });
      this.addEventListener('change', (event) => {
        if (event.target.matches('.cart-recommendations__variants')) {
          this.updateVariant(event.target);
        }
      }, { signal });
      this.track.addEventListener('scroll', () => this.updateNavigation(), { passive: true, signal });
      this.resizeObserver = new ResizeObserver(() => this.updateNavigation());
      this.resizeObserver.observe(this.track);
      this.updateNavigation();
    }

    selectMaterial(card, material) {
      const select = card.querySelector('.cart-recommendations__variants');
      if (!select || !card.variantOptions) return;
      const previous = select.selectedOptions[0];
      const matches = card.variantOptions.filter((option) => option.dataset.material === material);
      if (!matches.length) return;
      // Keep the chosen size where possible, otherwise select an available size.
      const selected = matches.find((option) => !option.disabled && option.value === previous?.value)
        || matches.find((option) => !option.disabled && option.dataset.choice === previous?.dataset.choice)
        || matches.find((option) => !option.disabled && option.dataset.size && option.dataset.size === previous?.dataset.size)
        || matches.find((option) => !option.disabled)
        || matches[0];
      select.replaceChildren(...matches.map((option) => {
        const copy = option.cloneNode(true);
        copy.textContent = copy.dataset.sizeLabel;
        return copy;
      }));
      select.value = selected.value;
      card.querySelectorAll('button[data-material]').forEach((button) => {
        button.setAttribute('aria-pressed', String(button.dataset.material === material));
      });
      this.updateVariant(select);
    }

    updateVariant(select) {
      const option = select.selectedOptions[0];
      const card = select.closest('.cart-recommendations__card');
      if (!option || !card) return;
      card.querySelector('.product-price .theme-money').textContent = option.dataset.price;
      const button = card.querySelector('.cart-recommendations__action');
      button.disabled = option.disabled;
      const quantity = select.form?.querySelector('[name="quantity"]');
      if (quantity) quantity.value = option.dataset.quantity;
      card.querySelectorAll('.cart-recommendations__product').forEach((link) => {
        const url = new URL(link.href, document.baseURI);
        url.searchParams.set('variant', option.value);
        link.href = url.href;
      });
      const image = card.querySelector('.cart-recommendations__image img');
      if (image && option.dataset.image) {
        image.removeAttribute('srcset');
        image.src = option.dataset.image;
        image.alt = option.dataset.imageAlt;
      }
    }

    updateNavigation() {
      const maximum = this.track.scrollWidth - this.track.clientWidth;
      const position = Math.abs(this.track.scrollLeft);
      this.navigation.hidden = maximum <= 2;
      this.previous.disabled = position <= 2;
      this.next.disabled = position >= maximum - 2;
    }

    disconnectedCallback() {
      this.controller?.abort();
      this.resizeObserver?.disconnect();
      this.controller = null;
    }
  });
}
